<ng-container ngForm appPromptUnsubmitted>
    <td>
        <input type="text"
               name="collDate"
               class="form-control"
               [(ngModel)]="video.date"
               [appIsInvalid]="!video.date"
               [submitted]="wasSubmitted"
               [bsConfig]="{dateInputFormat: 'MM/YYYY', minMode: 'month'}"
               bsDatepicker
               readonly>
        <div class="invalid-feedback">
            Date is Required
        </div>
    </td>
    <td>
        <input type="text" id="title" name="title" class="form-control" [appIsInvalid]="!video.title"
            [submitted]="wasSubmitted" [(ngModel)]="video.title" required>
        <div class="invalid-feedback">
            The Title is required
        </div>
    </td>
    <td>
        <input class="form-control" id="videoUrl" name="videoUrl" type="text"
            [appIsInvalid]="!video.videoUrl" [submitted]="wasSubmitted" [(ngModel)]="video.videoUrl">

        <div class="invalid-feedback">
            The Title is required
        </div>
    </td>
    <td>
        <textarea class="form-control" autosize id="description" name="description" type="text"
            [(ngModel)]="video.description"></textarea>

    </td>

    <ng-container *ngIf="!isEditVideo; else editAction">
        <td class="table-button">
            <button type="button" class="btn btn-primary" (click)="save()">Add</button>
        </td>
    </ng-container>

    <ng-template #editAction>
        <td class="table-button">
            <div class="button-set">
                <a class="text-primary" (click)="saveEdit()"><i class="icon-check"></i></a>
                <a class="text-danger" (click)="revert()"><i class="icon-close"></i></a>
            </div>
            <a *ngIf="currentUser?.permissions.canManagePlantingAreas" class="edit" title="Edit" (click)="openEdit()"><i class="icon-note"></i></a>
            <a *ngIf="currentUser?.permissions.canManagePlantingAreas" class="delete" title="Delete" (click)="delete()"><i class="icon-trash"></i></a>
        </td>
    </ng-template>
</ng-container>